// extracted by mini-css-extract-plugin
export default {"productCarousel":"n1-z"};